import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Login from "../components/Login.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Login, { msg: "Login." }))
}
}

})